<template>
    <div class="text" :style="{ maxHeight: col.maxHeight }">
        <span class="inner-text">
            {{ text }}
        </span>
    </div>
</template>

<script>
export default {
    name: 'LineBreakText',
    props: ['data', 'row', 'col'],
    computed: {
        text () {
            return this.data || '';
        },
    },
};
</script>

<style lang="less" scoped>
.inner-text {
    vertical-align: middle;
    white-space: pre-line;
    display: inline-block;
    line-height: 16px;
}
</style>
